import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusAvailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
			fill: "var(--color-green-300)"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_61_2010)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.83342 11.5L7.04175 9.70834C6.88897 9.55556 6.69453 9.47917 6.45842 9.47917C6.2223 9.47917 6.02786 9.55556 5.87508 9.70834C5.7223 9.86112 5.64592 10.0556 5.64592 10.2917C5.64592 10.5278 5.7223 10.7222 5.87508 10.875L8.25008 13.25C8.41675 13.4167 8.61119 13.5 8.83342 13.5C9.05564 13.5 9.25008 13.4167 9.41675 13.25L14.1251 8.54167C14.2779 8.38889 14.3542 8.19445 14.3542 7.95834C14.3542 7.72223 14.2779 7.52778 14.1251 7.37501C13.9723 7.22223 13.7779 7.14584 13.5417 7.14584C13.3056 7.14584 13.1112 7.22223 12.9584 7.37501L8.83342 11.5ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1146 6.75008 17.6771C5.73619 17.2396 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2639 2.323 13.25C1.8855 12.2361 1.66675 11.1528 1.66675 10C1.66675 8.84723 1.8855 7.76389 2.323 6.75001C2.7605 5.73612 3.35425 4.85417 4.10425 4.10417C4.85425 3.35417 5.73619 2.76042 6.75008 2.32292C7.76397 1.88542 8.8473 1.66667 10.0001 1.66667C11.1529 1.66667 12.2362 1.88542 13.2501 2.32292C14.264 2.76042 15.1459 3.35417 15.8959 4.10417C16.6459 4.85417 17.2397 5.73612 17.6772 6.75001C18.1147 7.76389 18.3334 8.84723 18.3334 10C18.3334 11.1528 18.1147 12.2361 17.6772 13.25C17.2397 14.2639 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2396 13.2501 17.6771C12.2362 18.1146 11.1529 18.3333 10.0001 18.3333Z",
				fill: "var(--color-green-900)"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_61_2010",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
export default SvgStatusAvailable;
